import i18n from 'resources/locales/i18n'

export const StatusTypesOrder = {
  invited: 1,
  'records-only': 2,
  'new-lead': 3,
  observation: 4,
  'active-treatment': 5,
  retention: 6,
  archived: 7
}

export const ScanFrequencyOptions = {
  'active-treatment': [7, 14, 21, 28],
  observation: [3, 6],
  retention: [3, 6]
}

export const scanFrequencyCustomOption = {
  label: i18n.t('dialogs.scanFrequency.custom'),
  value: 'custom'
}

const DEFAULT_SCAN_FREQUENCY_STATUS_TYPE = 'active-treatment'
// Keep this paired with the active-treatment fallback options above.
const DEFAULT_SCAN_FREQUENCY_PERIOD_TYPE = 'day'

export const getScanFrequencyOptionsForStatus = ({ areScanSettingsDisabled, postConfirmationStatus, status }) => {
  const statusType = areScanSettingsDisabled
    ? postConfirmationStatus?.type || DEFAULT_SCAN_FREQUENCY_STATUS_TYPE
    : status?.type

  return ScanFrequencyOptions[statusType] || ScanFrequencyOptions[DEFAULT_SCAN_FREQUENCY_STATUS_TYPE]
}

export const buildScanFrequencyOptions = ({ areScanSettingsDisabled, postConfirmationStatus, status, t }) => {
  const options = getScanFrequencyOptionsForStatus({ areScanSettingsDisabled, postConfirmationStatus, status })
  const scanFrequencyDefaultsSource = areScanSettingsDisabled ? postConfirmationStatus : status
  const statusScanDefaults = JSON.parse(scanFrequencyDefaultsSource?.scanFrequencyDefaults || '{}')
  const periodType = statusScanDefaults.periodType || DEFAULT_SCAN_FREQUENCY_PERIOD_TYPE

  return {
    statusScanDefaults,
    frequencyOptions: options
      .map(option => ({
        label: option.toString().concat(' ' + t(`periodTypes.${periodType}`)),
        value: option
      }))
      .concat(scanFrequencyCustomOption)
  }
}

export const DEFAULT_PERIOD_TYPE_OPTIONS = ['day', 'month']
const periodTypeOptionsByStatus = {
  'active-treatment_rm': ['day'],
  'active-treatment_rc': ['day'],
  'active-treatment_ortho': ['day']
}

export const getPeriodTypeOptions = statusKey =>
  (periodTypeOptionsByStatus[statusKey] || DEFAULT_PERIOD_TYPE_OPTIONS).map(periodType => ({
    label: i18n.t(`periodTypes.${periodType}`),
    value: periodType
  }))

const getStatusTypeFallbackFromKey = statusKey => {
  if (!statusKey || typeof statusKey !== 'string') {
    return undefined
  }

  const separatorIndex = statusKey.lastIndexOf('_')
  return separatorIndex === -1 ? statusKey : statusKey.slice(0, separatorIndex)
}

export const getStatusTypeByKey = ({ statusesByProgram = {}, program, statusKey } = {}) => {
  if (!statusKey) {
    return undefined
  }

  const programStatuses = program ? statusesByProgram?.[program] : null
  const allStatuses = Object.values(statusesByProgram || {}).reduce(
    (result, statuses) => [...result, ...(statuses || [])],
    []
  )

  return (
    programStatuses?.find(status => status.key === statusKey)?.type ||
    allStatuses.find(status => status.key === statusKey)?.type ||
    getStatusTypeFallbackFromKey(statusKey)
  )
}

export const isPatientActive = patient => {
  if (!patient) {
    return false
  }

  const status = patient?.treatments?.items[0]?.currentStatus?.status
  return status?.scanCyclesEnabled
}
